export default __webpack_public_path__ + "static/media/icon-alert-privacy.e5cc9830.svg";